/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TeamPlannerGroupDtoPage } from '../../models/team-planner-group-dto-page';

export interface ListTeamPlannerGroupsAdded$Params {
  teamPlannerId: string;
  query?: string;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'groupName' | '-groupName'>;
}

export function listTeamPlannerGroupsAdded(http: HttpClient, rootUrl: string, params: ListTeamPlannerGroupsAdded$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamPlannerGroupDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listTeamPlannerGroupsAdded.PATH, 'get');
  if (params) {
    rb.query('teamPlannerId', params.teamPlannerId, {});
    rb.query('query', params.query, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TeamPlannerGroupDtoPage>;
    })
  );
}

listTeamPlannerGroupsAdded.PATH = '/v0/teamPlanners/{id}/groups-added';
